export const blockIconsTransportationElectricScooterNew = (
	<span className='material-symbols-outlined'>electric_scooter</span>
);
